// extracted by mini-css-extract-plugin
export default {"firstP":"AboutPage_firstP__U2mNa"};